import { LRUCache } from 'lru-cache';

export const memoryCache = new LRUCache({
  max: 1000,
  ttl: 60 * 60 * 1000 // 1 hour
});
